/* (ignored) */


/*****************
 ** WEBPACK FOOTER
 ** vertx (ignored)
 ** module id = 7
 ** module chunks = 0
 **/